import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneButton.styl';
import "./BXmakerAuthuserphoneLoader";

/**
 * @event onClick {}
 */
Vue.component('BXmakerAuthuserphoneButton',
    {
        props: {
            title: {
                type: String,
                default: ' - '
            },
            loader: {
                type: Boolean,
                default: false,
            },
            white: {
                type: Boolean,
                default: false,
            }
        },
        data: function () {
            return {};
        },
        methods: {
            onClick(e) {
                this.$emit('onClick')
            }
        },
        template: `
            <button class="bxmaker-authuserphone-button" 
            :class="{'bxmaker-authuserphone-button--white': white}"
            type="button"  
            @click="onClick" 
            tabindex="0" 
            role="button"
            >
                <div class="bxmaker-authuserphone-button__inner">                   
                    <BXmakerAuthuserphoneLoader v-if="loader" />           
                    <div class="bxmaker-authuserphone-button__title" v-else >{{title}}</div>                 
                </div>                 
            </button>
        `,
    });